import KubernetesPricingTable from "@/views/pricing/components/tables/kubernetes";

const KubernetesPricing = () => {
  return <KubernetesPricingTable />;
};

export default KubernetesPricing;
